import { Component } from "@angular/core";

@Component({
    selector: "app-nav-rail-container",
    templateUrl: "./nav-rail-container.component.html",
    styleUrls: ["./nav-rail-container.component.scss"],
    standalone: true,
})
export class NavRailContainerComponent {}
